export default __webpack_public_path__ + "b255b08635325e3d3f5820652feeece4.png";